import { fetchDailyJetLagStatusSuccess } from 'actions/jetLagActions';
import {
    SAVE_JET_LAG_TRIP,
    SAVE_JET_LAG_TRIP_SUCCESS,
    SAVE_JET_LAG_TRIP_FAIL,
    FETCH_JET_LAG_TRIPS_FETCHING,
    FETCH_JET_LAG_TRIPS_SUCCESS,
    FETCH_JET_LAG_TRIPS_FAIL,
    FETCH_JET_LAG_TRIPS,
    FETCH_DAILY_JET_LAG_STATUS,
    FETCH_DAILY_JET_LAG_STATUS_START,
    FETCH_DAILY_JET_LAG_STATUS_FAIL,
    DELETE_JET_LAG_TRIP,
    DELETE_JET_LAG_TRIP_START,
    DELETE_JET_LAG_TRIP_SUCCESS,
    DELETE_JET_LAG_TRIP_FAIL,
    UPDATE_JET_LAG_TRIP,
    UPDATE_JET_LAG_TRIP_SUCCESS,
    UPDATE_JET_LAG_TRIP_FAIL
} from 'actions/ActionTypes';
import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from '../config/axios';

export function* saveJetLagTrip(action) {
    try {
        const { flights, userId, startDate, endDate } = action.payload;

        const payload = {
            userId: userId,
            startDate: startDate,
            endDate: endDate,
            flights: flights
        };
        const response = yield call(gcApi.post, `/jetlag-service/jetlag/trip`, payload);

        yield put({
            type: SAVE_JET_LAG_TRIP_SUCCESS,
            payload: response.data || {}
        });
    } catch (e) {
        yield put({
            type: SAVE_JET_LAG_TRIP_FAIL
        });
    }
}

export function* fetchAllJetLagTrips(action) {
    try {
        yield put({
            type: FETCH_JET_LAG_TRIPS_FETCHING
        });

        const response = yield call(gcApi.get, `/jetlag-service/jetlag/trip/all`);

        yield put({
            type: FETCH_JET_LAG_TRIPS_SUCCESS,
            payload: response.data || {}
        });
    } catch (e) {
        yield put({
            type: FETCH_JET_LAG_TRIPS_FAIL
        });
    }
}

export function* fetchDailyJetLagStatus(action) {
    try {
        const { calendarDate } = action.payload;

        yield put({
            type: FETCH_DAILY_JET_LAG_STATUS_START
        });

        const response = yield call(gcApi.get, `/jetlag-service/jetlag/status/daily/${calendarDate}`);

        yield put(
            fetchDailyJetLagStatusSuccess({
                calendarDate,
                data: response.data || {},
                status: response.status
            })
        );
    } catch (e) {
        yield put({
            type: FETCH_DAILY_JET_LAG_STATUS_FAIL
        });
    }
}

export function* deleteJetLagTrip(action) {
    try {
        const { tripId } = action.payload;

        yield put({
            type: DELETE_JET_LAG_TRIP_START
        });

        const response = yield call(gcApi.delete, `/jetlag-service/jetlag/trip/${tripId}`);

        yield put({
            type: DELETE_JET_LAG_TRIP_SUCCESS,
            payload: tripId
        });
    } catch (e) {
        yield put({
            type: DELETE_JET_LAG_TRIP_FAIL
        });
    }
}

export function* updateJetLagTrip(action) {
    try {
        const { trip, flights, startDate, endDate } = action.payload;

        const payload = {
            ...trip,
            flights: flights,
            startDate,
            endDate
        };

        const response = yield call(gcApi.put, `/jetlag-service/jetlag/trip`, payload);

        yield put({
            type: UPDATE_JET_LAG_TRIP_SUCCESS,
            payload
        });
    } catch (e) {
        yield put({
            type: UPDATE_JET_LAG_TRIP_FAIL
        });
    }
}

export const jetLagSagas = [
    takeEvery(SAVE_JET_LAG_TRIP, saveJetLagTrip),
    takeEvery(FETCH_JET_LAG_TRIPS, fetchAllJetLagTrips),
    takeEvery(FETCH_DAILY_JET_LAG_STATUS, fetchDailyJetLagStatus),
    takeEvery(DELETE_JET_LAG_TRIP, deleteJetLagTrip),
    takeEvery(UPDATE_JET_LAG_TRIP, updateJetLagTrip)
];
